import { AppLauncher } from '@capacitor/app-launcher'

export const OpenUrl = {
  methods: {
    async open_url(url) {
      const opened = await AppLauncher.openUrl({ url: url })
      if (!opened.completed) {
        window.open(url,'_system', 'noreferrer')
      }
    }
  }
}